import { defineDrupalBehavior } from '@lib/defineDrupalBehavior';

interface HistoryGoParams {
    go: number;
    fallback?: string;
}

defineDrupalBehavior<HTMLButtonElement>('HistoryGo', '[data-history-go]', (button) => {
    if ((!history.state || typeof history.state.page !== 'number') && typeof history.replaceState === 'function') {
        history.replaceState({ ...(history.state || {}), page: history.length }, '');
    }

    button.addEventListener('click', (e) => {
        if (e.defaultPrevented) return;

        const { go, fallback } = getParams(button);
        let needsFallback = false;

        if (history.state) {
            const currentPage: number = history.state.page;

            if (go < 0 && go * -1 >= currentPage) needsFallback = true;
            if (go > 0 && go > history.length - currentPage) needsFallback = true;
        } else if (go < 0 && go * -1 >= history.length) {
            needsFallback = true;
        }

        if (needsFallback && fallback) {
            window.location.href = fallback;
        } else {
            window.history.go(go);
        }
    });
});

function getParams(button: HTMLButtonElement): HistoryGoParams {
    return {
        go: parseInt(button.dataset['historyGo'] || '0', 10),
        fallback: button.dataset['historyFallback'],
    };
}
